module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Net Worth":"Всего денег","No transactions":"Нет транзакций за этот период"}}')
  delete Component.options._Ctor
}
